//Styles
import assessStyles from "../../../../../styles/assessments/Assessment.module.css"

//Formik helpers
import FormikNumberInput from "../../../../../helpers/formikInputs/FormikNumberInput"
import FormikRadioButtonInput from "../../../../../helpers/formikInputs/FormikRadioButtonInput"

//Assessments components
import elementTypes from "../Elements/elementTypes"

export default function QuestionHeight({
  formikQuestionName,
  questionType,
  disabled,
}) {
  let Component = null

  if (
    [elementTypes.headingElementId, elementTypes.descriptionElementId].includes(
      questionType
    )
  ) {
    Component = (
      <div className={assessStyles.selectButton}>
        <FormikRadioButtonInput
          name={`${formikQuestionName}.height`}
          label={"Size"}
          options={[
            { label: "Small", value: 1 },
            { label: "Medium", value: 2 },
            { label: "Large", value: 3 },
          ]}
          optionLabel={"label"}
          optionValue={"value"}
          useSelectButton={true}
          disabled={disabled}
        />
      </div>
    )
  } else {
    Component = (
      <FormikNumberInput
        name={`${formikQuestionName}.height`}
        helpText={
          elementTypes.paragraphElementId === questionType
            ? "Select the rows shown for the paragraph"
            : ""
        }
        label={"Height"}
        useSlider={true}
        minValue={elementTypes.paragraphElementId === questionType ? 3 : 1}
        maxValue={10}
        minFractionDigits={0}
        disabled={disabled}
      />
    )
  }

  return Component
}
